/* tslint:disable */
/* eslint-disable */
/**
 * Carrot Config Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The "ClientType" Enum
 * @export
 */
export const ClientType = {
    RealEstate: 'REAL_ESTATE',
    Mwm: 'MWM'
};
export function instanceOfClientType(value) {
    for (const key in ClientType) {
        if (Object.prototype.hasOwnProperty.call(ClientType, key)) {
            if (ClientType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function ClientTypeFromJSON(json) {
    return ClientTypeFromJSONTyped(json, false);
}
export function ClientTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ClientTypeToJSON(value) {
    return value;
}
//# sourceMappingURL=ClientType.js.map